module.exports = __webpack_public_path__ + "static/AvenirNext-UltraLightItalic-3b25e1a6ce160d4405ad3d9863a9e7f7.woff2";